(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq_item"] && !Shopify.designMode) return;
  try {
    class WspFaqItem extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.wsp-faq-item__question');
      this.answer = this.querySelector('.wsp-faq-item__answer');
      if (!this.button || !this.answer) return;
      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const isOpen = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', String(!isOpen));
      this.answer.hidden = isOpen;
    }
  }

  if (!customElements.get('wsp-faq-item')) {
    customElements.define('wsp-faq-item', WspFaqItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      let activeId = null;
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.activate(trigger.dataset.tabTrigger));
        if (!activeId && trigger.classList.contains('is-active')) {
          activeId = trigger.dataset.tabTrigger;
        }
      });

      this.activate(activeId || (this.triggers[0] && this.triggers[0].dataset.tabTrigger));
    }

    activate(id) {
      if (!id) return;
      this.triggers.forEach((trigger) => {
        const active = trigger.dataset.tabTrigger === id;
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== id;
      });
    }
  }

  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["samlaunch-faq_item"] && !Shopify.designMode) return;
  try {
    class WspFaqItem extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.wsp-faq-item__question');
      this.answer = this.querySelector('.wsp-faq-item__answer');
      if (!this.button || !this.answer) return;
      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const isOpen = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', String(!isOpen));
      this.answer.hidden = isOpen;
    }
  }

  if (!customElements.get('wsp-faq-item')) {
    customElements.define('wsp-faq-item', WspFaqItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wsp-bundle-selector"] && !Shopify.designMode) return;
  try {
    class WspBundleSelector extends HTMLElement {
    connectedCallback() {
      this.radios = Array.from(this.querySelectorAll('.wsp-bundle-option__radio'));
      this.submitBtn = this.querySelector('.wsp-bundle-selector__submit');
      this.submitText = this.querySelector('.wsp-bundle-selector__submit-text');
      this.spinner = this.querySelector('.wsp-bundle-selector__submit-spinner');
      this.errorEl = this.querySelector('.wsp-bundle-selector__error');
      this.defaultButtonText = this.submitText ? this.submitText.textContent : '';
      this.variantHtmlCache = new Map();
      const giftConfig = this.querySelector('[data-wsp-bundle-gifts]');
      try {
        this.bundleGifts = JSON.parse(giftConfig?.textContent || '{}');
      } catch (error) {
        console.error('wsp-bundle-selector: invalid gift configuration', error);
        this.bundleGifts = {};
      }

      this.radios.forEach((radio) =>
        radio.addEventListener('change', () => {
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
          this.updateSelection();
          this.syncNativeBlocks(radio.value);
        })
      );
      this.submitBtn.addEventListener('click', () => this.addToCart());

      this.updateSelection(true);
      const initialSelection = this.radios.find((radio) => radio.checked);
      if (initialSelection) this.syncNativeBlocks(initialSelection.value);
      this.prefetchVariantSections();
    }

    prefetchVariantSections() {
      const productUrl = this.dataset.productUrl;
      const sectionId = this.dataset.sectionId;
      if (!productUrl || !sectionId) return;

      this.radios.forEach((radio) => {
        if (!radio.value || this.variantHtmlCache.has(radio.value)) return;
        fetch(`${productUrl}?variant=${radio.value}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => this.variantHtmlCache.set(radio.value, responseText))
          .catch(() => {});
      });
    }

    updateSelection(isInitial) {
      this.querySelectorAll('.wsp-bundle-option').forEach((option) => {
        const radio = option.querySelector('.wsp-bundle-option__radio');
        const isSelected = !!radio && radio.checked;
        option.classList.toggle('is-selected', isSelected);

        const detail = option.querySelector('.wsp-bundle-option__detail');
        if (!detail) return;

        if (isSelected) {
          if (isInitial) {
            detail.style.maxHeight = 'none';
          } else {
            detail.style.maxHeight = detail.scrollHeight + 'px';
            window.setTimeout(() => {
              if (radio.checked) detail.style.maxHeight = 'none';
            }, 340);
          }
        } else if (!isInitial || detail.style.maxHeight !== '0px') {
          detail.style.maxHeight = detail.scrollHeight + 'px';
          requestAnimationFrame(() => {
            detail.style.maxHeight = '0';
          });
        }
      });

      const selected = this.radios.find((radio) => radio.checked);
      this.submitBtn.disabled = !selected;
    }

    async syncNativeBlocks(variantId) {
      const productUrl = this.dataset.productUrl;
      const sectionId = this.dataset.sectionId;
      if (!productUrl || !sectionId || !variantId) return;

      try {
        let responseText = this.variantHtmlCache.get(variantId);
        if (!responseText) {
          const response = await fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`);
          responseText = await response.text();
          this.variantHtmlCache.set(variantId, responseText);
        }
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        this.dispatchEvent(
          new CustomEvent('variant:update', {
            bubbles: true,
            detail: {
              resource: { id: variantId },
              sourceId: this.id || 'wsp-bundle-selector',
              data: {
                html,
                productId: this.dataset.productId,
              },
            },
          })
        );

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url.toString());
      } catch (error) {
        console.error('wsp-bundle-selector: failed to sync native product blocks', error);
      }
    }

    async addToCart() {
      const selected = this.radios.find((radio) => radio.checked);
      if (!selected || !selected.value || this.submitBtn.disabled) return;

      const variantId = selected.value;

      this.submitBtn.disabled = true;
      this.spinner.hidden = false;
      this.errorEl.hidden = true;

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionIds = [];
      cartItemsComponents.forEach((el) => {
        if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      try {
        const cartRoot = window.Shopify?.routes?.root || '/';
        const addUrl = `${cartRoot}cart/add.js`;
        const gifts = this.bundleGifts?.[variantId] || [];
        const items = [
          { id: Number(variantId), quantity: 1 },
          ...gifts.map(([id, quantity, code]) => ({
            id: Number(id),
            quantity: Number(quantity),
            properties: {
              _wsp_promotion_gift: 'true',
              _wsp_bundle_parent: String(variantId),
              _wsp_gift_per_bundle: String(quantity),
              _wsp_gift_code: code,
            },
          })),
        ];
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        const cartResponse = await fetch(`${cartRoot}cart.js`);
        const cart = await cartResponse.json();
        const paidItemCount = (cart.items || []).reduce(
          (total, item) => item.properties?._wsp_promotion_gift === 'true' ? total : total + item.quantity,
          0
        );

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.id || 'wsp-bundle-selector',
              data: {
                source: 'wsp-bundle-selector',
                itemCount: paidItemCount,
                variantId,
                sections: data.sections,
              },
            },
          })
        );

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } catch (error) {
        this.errorEl.textContent = (error && error.message) || this.dataset.errorMessage || 'Add to cart failed, please try again';
        this.errorEl.hidden = false;
      } finally {
        this.spinner.hidden = true;
        this.submitBtn.disabled = false;
      }
    }
  }

  if (!customElements.get('wsp-bundle-selector')) {
    customElements.define('wsp-bundle-selector', WspBundleSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wsp-single-bundle-selector"] && !Shopify.designMode) return;
  try {
    class WspSingleBundleSelector extends HTMLElement {
    connectedCallback() {
      this.radios = Array.from(this.querySelectorAll('.wsp-bundle-option__radio'));
      this.submitBtn = this.querySelector('.wsp-single-bundle-selector__submit');
      this.submitText = this.querySelector('.wsp-single-bundle-selector__submit-text');
      this.spinner = this.querySelector('.wsp-single-bundle-selector__submit-spinner');
      this.errorEl = this.querySelector('.wsp-single-bundle-selector__error');
      this.defaultButtonText = this.submitText ? this.submitText.textContent : '';
      this.variantHtmlCache = new Map();
      const giftConfig = this.querySelector('[data-wsp-bundle-gifts]');
      try {
        this.bundleGifts = JSON.parse(giftConfig?.textContent || '{}');
      } catch (error) {
        console.error('wsp-single-bundle-selector: invalid gift configuration', error);
        this.bundleGifts = {};
      }

      this.radios.forEach((radio) =>
        radio.addEventListener('change', () => {
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
          this.updateSelection();
          this.syncNativeBlocks(radio.value);
        })
      );
      this.submitBtn.addEventListener('click', () => this.addToCart());

      this.updateSelection(true);
      const initialSelection = this.radios.find((radio) => radio.checked);
      if (initialSelection) this.syncNativeBlocks(initialSelection.value);
      this.prefetchVariantSections();
    }

    prefetchVariantSections() {
      const productUrl = this.dataset.productUrl;
      const sectionId = this.dataset.sectionId;
      if (!productUrl || !sectionId) return;

      this.radios.forEach((radio) => {
        if (!radio.value || this.variantHtmlCache.has(radio.value)) return;
        fetch(`${productUrl}?variant=${radio.value}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => this.variantHtmlCache.set(radio.value, responseText))
          .catch(() => {});
      });
    }

    updateSelection(isInitial) {
      this.querySelectorAll('.wsp-bundle-option').forEach((option) => {
        const radio = option.querySelector('.wsp-bundle-option__radio');
        const isSelected = !!radio && radio.checked;
        option.classList.toggle('is-selected', isSelected);

        const detail = option.querySelector('.wsp-bundle-option__detail');
        if (!detail) return;

        if (isSelected) {
          if (isInitial) {
            detail.style.maxHeight = 'none';
          } else {
            detail.style.maxHeight = detail.scrollHeight + 'px';
            window.setTimeout(() => {
              if (radio.checked) detail.style.maxHeight = 'none';
            }, 340);
          }
        } else if (!isInitial || detail.style.maxHeight !== '0px') {
          detail.style.maxHeight = detail.scrollHeight + 'px';
          requestAnimationFrame(() => {
            detail.style.maxHeight = '0';
          });
        }
      });

      const selected = this.radios.find((radio) => radio.checked);
      this.submitBtn.disabled = !selected;
    }

    async syncNativeBlocks(variantId) {
      const productUrl = this.dataset.productUrl;
      const sectionId = this.dataset.sectionId;
      if (!productUrl || !sectionId || !variantId) return;

      try {
        let responseText = this.variantHtmlCache.get(variantId);
        if (!responseText) {
          const response = await fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`);
          responseText = await response.text();
          this.variantHtmlCache.set(variantId, responseText);
        }
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        this.dispatchEvent(
          new CustomEvent('variant:update', {
            bubbles: true,
            detail: {
              resource: { id: variantId },
              sourceId: this.id || 'wsp-single-bundle-selector',
              data: {
                html,
                productId: this.dataset.productId,
              },
            },
          })
        );

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url.toString());
      } catch (error) {
        console.error('wsp-single-bundle-selector: failed to sync native product blocks', error);
      }
    }

    async addToCart() {
      const selected = this.radios.find((radio) => radio.checked);
      if (!selected || !selected.value || this.submitBtn.disabled) return;

      const variantId = selected.value;

      this.submitBtn.disabled = true;
      this.spinner.hidden = false;
      this.errorEl.hidden = true;

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionIds = [];
      cartItemsComponents.forEach((el) => {
        if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      try {
        const cartRoot = window.Shopify?.routes?.root || '/';
        const addUrl = `${cartRoot}cart/add.js`;
        const gifts = this.bundleGifts?.[variantId] || [];
        const items = [
          { id: Number(variantId), quantity: 1 },
          ...gifts.map(([id, quantity, code]) => ({
            id: Number(id),
            quantity: Number(quantity),
            properties: {
              _wsp_promotion_gift: 'true',
              _wsp_bundle_parent: String(variantId),
              _wsp_gift_per_bundle: String(quantity),
              _wsp_gift_code: code,
            },
          })),
        ];
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        const cartResponse = await fetch(`${cartRoot}cart.js`);
        const cart = await cartResponse.json();
        const paidItemCount = (cart.items || []).reduce(
          (total, item) => item.properties?._wsp_promotion_gift === 'true' ? total : total + item.quantity,
          0
        );

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.id || 'wsp-single-bundle-selector',
              data: {
                source: 'wsp-single-bundle-selector',
                itemCount: paidItemCount,
                variantId,
                sections: data.sections,
              },
            },
          })
        );

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } catch (error) {
        this.errorEl.textContent = (error && error.message) || this.dataset.errorMessage || 'Add to cart failed, please try again';
        this.errorEl.hidden = false;
      } finally {
        this.spinner.hidden = true;
        this.submitBtn.disabled = false;
      }
    }
  }

  if (!customElements.get('wsp-single-bundle-selector')) {
    customElements.define('wsp-single-bundle-selector', WspSingleBundleSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
